<template>
  <v-container
    fill-height
    align-center
    justify-center
    class="current-plan-view"
  >
    <page-title title="Current Plan"></page-title>
    <v-progress-circular indeterminate v-if="loading"></v-progress-circular>
    <v-card flat class="current-plan pa-4" v-if="!loading">
      <v-layout column>
        <v-flex class="plan-details">
          <div class="plan-name">{{ plan.plan.name }}</div>
          <div class="plan-spec">{{ plan.plan.feedback_limit }} feedback responses/month</div>
              <div class="plan-spec">{{ plan.plan.proof_limit }} social proof cards/month</div>
        </v-flex>
        <v-flex class="price-details">
          <div class="price">{{ plan.plan.currency.symbol }}{{ price }}</div>
          <div class="price-interval">{{ billingCycle }}</div>
          <div class="expiry-info" v-html="status.text"></div>
        </v-flex>
        <v-flex class="subscription-actions"
          ><v-btn
            class="add-user-btn"
            color="accent"
            medium
            depressed
            @click="clickAction"
            :loading="paymentScreen"
          >
            {{ status.buttonText }}
          </v-btn></v-flex
        >
        <v-flex style="text-align: center;margin-top: 15px;opacity: .5">
          <img class="ssl" :src="require('@/assets/logo-mastercard.svg')" />
          <img class="ssl" :src="require('@/assets/logo-visa.svg')" />
          <img class="ssl" :src="require('@/assets/logo-amex.svg')" />
          <img class="ssl" :src="require('@/assets/logo-paypal.svg')" />
          <img class="ssl" :src="require('@/assets/logo-wire-transfers.svg')" />
          <!-- <img class="ssl" :src="require('@/assets/logo-apple-pay.svg')" /> -->
          <img class="ssl" :src="require('@/assets/ssl.png')" />
          
        </v-flex>
        <v-flex v-if="plan.status === 'PAID' || plan.status === 'PENDING'" class="cancel-subscription" @click="cancelSubDialog=true">
          
          <div>Cancel Subscription</div>
        </v-flex>
      </v-layout>
    </v-card>
    <PaymentScreen v-model="paymentScreen" 
                    :subscription="plan" 
                    @planUpdateSuccess="planUpdateSuccess"
                    @planUpdateFail="planUpdateFail"></PaymentScreen>
    <LgDialog
          v-model="cancelSubDialog"
          title="Cancel Subscription"
          content="You no longer able to view the insights."
          primary-action-text="Delete"
          secondary-action-text="Cancel"
          :titleBg="colors.theme.warning"
          @secondaryActionClick="cancelSubDialog = false"
        >
          <template v-slot:content>
            <v-container grid-list-md class="mt-2">
              Cancelling the subscription will cause your account not process additional feedback responses and proof widget disaply. Do you really want to cancel? 
              <v-layout wrap v-if="$store.getters['user/details'].role === 'OWNER'" column>
                
                <v-flex>
                  <v-text-field 
                  :rules="[rules.required, rules.min]"
                  v-model="currentPassword" 
                  label="Current password" 
                  type="password"
                  required></v-text-field>
                </v-flex>
              </v-layout>  
            </v-container>
          </template>
          <template v-slot:actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              color="primaryLight4"
              outline
              @click="cancelSubDialog = false"
            >
              Cancel
            </v-btn>
            <v-btn
              color="warning"
              :loading="cancelSubLoading"
              depressed
              @click="cancelSubscription"
              :disabled="$store.getters['user/details'].role === 'OWNER' && currentPassword.length < 8"
            >
              Delete
            </v-btn>
          </template>
        </LgDialog>
  </v-container>
</template>

<script>
import format from 'date-fns/format'
import billingApi from '@/api/billing'
import constants from '@/constants'
import PaymentScreen from './PaymentScreen'
import LgDialog from '@/components/LgDialog'
export default {
  name: 'CurrentPlan',
  components: { PaymentScreen, LgDialog },
  mounted() {
    this.getSubscription()
  },
  data() {
    return {
      plan: null,
      loading: true,
      paymentScreen: false,
      cancelSubDialog: false,
      cancelSubLoading: false,
      rules: {
          required: value => !!value || 'Required.',
          min: v => v.length >= 8 || 'Min 8 characters',
      },
      currentPassword: '',
    }
  },
  computed: {
    price() {
      if (!this.plan) return ''
      if (this.plan.status === 'TRIAL') {
        return this.plan.plan.price
      } else {
        return this.plan.amount
      }
    },
    billingCycle() {
      if (!this.plan) return ''
      if (this.plan.billing_cycle === 'MONTHLY') {
        return 'Monthly'
      } else {
        return 'Yearly'
      }
    },
    status() {
      const d = { buttonText: 'Pay', text: '' }
      if (!this.plan) return d

      if (this.plan.id === 'STARTUP') {
        d.buttonText = 'Upgrade plan'
        d.text = `You are on <span class="subscription-status active">free</span> Plan. Enjoy!`
        return d
      }
      if (this.plan.status === 'TRIAL') {
        if (this.plan.remaining_trial_days > 0) {
          d.buttonText = 'Pay'
          d.text = `You are on
                    <span class="subscription-status active">trial</span> period with
                    <span class="expiry-date">${this.plan.remaining_trial_days} days left </span>`
          return d
        } else {
          d.buttonText = 'Pay now'
          d.text = `Your trial plan
                    <span class="subscription-status expired">expired</span> on <span class="expiry-date">${format(
                      new Date(this.plan.expires_at * 1000),
                      constants.defaultDateFormat
                    )}</span>. Please complete the payment immediately.`
          return d
        }
      } else if (this.plan.status === 'PENDING') {
        d.buttonText = 'Pay now'
        d.text = `Payment for this cycle <span class="subscription-status expired">failed</span>.
                    Please complete the payment at the earliest.`
        return d
      } else if (this.plan.status === 'PAID') {
        d.buttonText = 'Pay now'
        d.text = `Your subscription is  <span class="subscription-status active">Active</span> and will update on <span class="expiry-date">${format(
          new Date(this.plan.expires_at * 1000),
          constants.defaultDateFormat
        )}`
        return d
      }
    }
  },
  methods: {
    getSubscription() {
      const vm = this
      vm.loading = true
      billingApi
        .subscription(this.$store.getters['user/currentCampaign'].project_id)
        .then(function(res) {
          vm.plan = res.data.results
          vm.loading = false
        })
    },
    clickAction() {
      this.paymentScreen = true
    },
    cancelSubscription(){
      billingApi.cancelSubscription(this.$store.getters['user/currentCampaign'].project_id)
        .then(function(res) {
          vm.plan = res.data.results
          vm.loading = false
        })
    },
    planUpdateSuccess(data){
      console.log('planUpdateSuccess', data)
      this.loading = false
      this.paymentScreen = false
    },
    planUpdateFail(data){
      console.log('planUpdateFail', data)
      this.loading = false
      this.paymentScreen = false
    }
  }
}
</script>

<style lang="stylus">
.current-plan-view
    .current-plan
        width 460px
        border 1px solid $color-primary-light-8
        box-sizing border-box
        border-radius 5px
    .plan-details
        padding-top 30px
        padding-left 30px
        .plan-name
            font-weight: 600;
            font-size: 18px;
            color: $color-primary;
            margin-bottom 5px
        .plan-spec
            font-size: 14px
            color: $color-primary-light-5;
    .price-details
        text-align center
        margin-top 50px
        .price
            font-weight: bold;
            font-size: 36px;
            color: $color-accent
        .price-interval
            font-weight: normal
            font-size: 16px
            color: $color-primary-light-5
        .expiry-info
            padding-top 50px
            font-size: 14px;
            color: $color-primary-light-1
            .subscription-status
                font-weight 500
                &.active
                    color: $color-accent
                &.expired
                    color: $color-error
            .expiry-date
                color: $color-primary-light-1
                font-weight 500

    .subscription-actions
        margin-top 20px
        text-align center

    .cancel-subscription
        text-align right
        font-size: 12px;
        color: $color-primary-light-5
        margin-top 35px
        cursor pointer

    .ssl 
        height 20px
        margin-right 10px
</style>
